import React, { useState } from 'react';

const SOGLIA = 70;   // bontà = % NON TIM sui controllati; sotto questa soglia = zona da tenere d'occhio
const MIN_CTRL = 15; // ignora zone con pochi controllati (bontà non significativa)

/* Bontà numeri: per ogni area la quota di NON TIM tra i controllati (= "bontà"). */
function buildBonta(rows, tipo) {
  return rows
    .map((r) => {
      const tim = r.tim || 0;
      const non_tim = r.non_tim || 0;
      const ver = tim + non_tim;
      return { nome: r.nome, tipo, tim, non_tim, ver, bonta: ver ? Math.round((non_tim / ver) * 100) : null };
    })
    .filter((r) => r.ver >= MIN_CTRL && r.bonta < SOGLIA);
}

function bandaBonta(bonta) {
  if (bonta < 40) return '#ef4444';
  if (bonta < 55) return '#f59e0b';
  return '#eab308';
}

/* Verifiche 456: per ogni area la % di numeri già controllati sul totale. */
function buildVer(rows, tipo) {
  return rows
    .map((r) => {
      const tot = r.tot || 0;
      const done = r.controllati || 0;
      return { nome: r.nome, tipo, tot, done, pending: r.pending || 0, pct: tot ? Math.round((done / tot) * 100) : 0 };
    })
    .filter((r) => r.tot >= 1);
}

function bandaVer(pct) {
  if (pct < 40) return '#ef4444';
  if (pct < 75) return '#f59e0b';
  return '#22c55e';
}

const tabBtn = (active) => ({
  padding: '4px 10px', fontSize: 12, fontWeight: 600, borderRadius: 7, cursor: 'pointer',
  border: '1px solid ' + (active ? '#4895ef' : '#cbd5e1'),
  background: active ? '#4895ef' : '#fff', color: active ? '#fff' : '#64748b',
});

const vistaBtn = (active) => ({
  padding: '3px 8px', fontSize: 11, fontWeight: 600, borderRadius: 6, cursor: 'pointer',
  border: '1px solid ' + (active ? '#14746f' : '#cbd5e1'),
  background: active ? '#14746f' : '#fff', color: active ? '#fff' : '#64748b',
});

export default function QualityWidget({ regRows, provRows, kpi }) {
  const [tab, setTab] = useState('bonta');
  const [vista, setVista] = useState('entrambi');   // 'provincia' | 'regione' | 'entrambi'
  const tipiVisti = vista === 'entrambi' ? ['Regione', 'Provincia'] : (vista === 'regione' ? ['Regione'] : ['Provincia']);

  const bonta = [...buildBonta(regRows, 'Regione'), ...buildBonta(provRows, 'Provincia')]
    .filter((r) => tipiVisti.includes(r.tipo))
    .sort((a, b) => a.bonta - b.bonta);

  const ver = [...buildVer(regRows, 'Regione'), ...buildVer(provRows, 'Provincia')]
    .filter((r) => tipiVisti.includes(r.tipo))
    .sort((a, b) => a.pct - b.pct);
  // Totale allineato ai contatori KPI (includono gli ERRORE), così i numeri coincidono.
  const totTot = kpi?.total ?? provRows.reduce((s, r) => s + (r.tot || 0), 0);
  const totDone = kpi?.verificati ?? provRows.reduce((s, r) => s + (r.controllati || 0), 0);
  const totPct = totTot ? Math.round((totDone / totTot) * 100) : 0;

  return (
    <div className="evo-card qw-card">
      <div className="evo-card-head" style={{ gap: 8 }}>
        <div style={{ display: 'flex', gap: 6 }}>
          <button style={tabBtn(tab === 'bonta')} onClick={() => setTab('bonta')}>Bontà numeri</button>
          <button style={tabBtn(tab === 'verifiche')} onClick={() => setTab('verifiche')}>Verifiche 456</button>
        </div>
        <div style={{ display: 'flex', gap: 4 }}>
          <button style={vistaBtn(vista === 'provincia')} onClick={() => setVista('provincia')}>Provincia</button>
          <button style={vistaBtn(vista === 'regione')} onClick={() => setVista('regione')}>Regione</button>
          <button style={vistaBtn(vista === 'entrambi')} onClick={() => setVista('entrambi')}>Entrambi</button>
        </div>
        {tab === 'verifiche' && (
          <span className="qw-legend">Totale: <b style={{ color: bandaVer(totPct) }}>{totPct}%</b> ({totDone.toLocaleString('it-IT')}/{totTot.toLocaleString('it-IT')})</span>
        )}
      </div>

      {tab === 'bonta' && (
        <>
          <div className="qw-hint">Zone con pochi NON TIM utili (troppi TIM): conviene rifornire liste lì. Solo aree con ≥ {MIN_CTRL} controllati, sotto il {SOGLIA}%.</div>
          <div className="qw-scroll">
            {bonta.length === 0 && (
              <div className="evo-empty">Nessuna area sotto il {SOGLIA}%: i numeri sono buoni ovunque. 👍</div>
            )}
            {bonta.map((r) => (
              <div key={`b-${r.tipo}-${r.nome}`} className="qw-row">
                <span className={`qw-tag ${r.tipo === 'Regione' ? 'tg-reg' : 'tg-prov'}`}>{r.tipo === 'Regione' ? 'REG' : 'PRV'}</span>
                <span className="qw-name" title={r.nome}>{r.nome}</span>
                <span className="qw-bar"><span className="qw-seg" style={{ width: `${r.bonta}%`, background: bandaBonta(r.bonta) }} /></span>
                <span className="qw-bonta" style={{ color: bandaBonta(r.bonta) }}>{r.bonta}%</span>
                <span className="qw-ver">{r.ver.toLocaleString('it-IT')} ctrl.</span>
              </div>
            ))}
          </div>
        </>
      )}

      {tab === 'verifiche' && (
        <>
          <div className="qw-hint">% di numeri già verificati col 456 sul totale caricato, per area. In cima le aree meno lavorate.</div>
          <div className="qw-scroll">
            {ver.length === 0 && <div className="evo-empty">Nessun dato.</div>}
            {ver.map((r) => (
              <div key={`v-${r.tipo}-${r.nome}`} className="qw-row">
                <span className={`qw-tag ${r.tipo === 'Regione' ? 'tg-reg' : 'tg-prov'}`}>{r.tipo === 'Regione' ? 'REG' : 'PRV'}</span>
                <span className="qw-name" title={r.nome}>{r.nome}</span>
                <span className="qw-bar"><span className="qw-seg" style={{ width: `${r.pct}%`, background: bandaVer(r.pct) }} /></span>
                <span className="qw-bonta" style={{ color: bandaVer(r.pct) }}>{r.pct}%</span>
                <span className="qw-ver">{r.done.toLocaleString('it-IT')}/{r.tot.toLocaleString('it-IT')}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
